import { render } from "./PaymentContent.vue?vue&type=template&id=64139fe8&scoped=true"
import script from "./PaymentContent.vue?vue&type=script&lang=js"
export * from "./PaymentContent.vue?vue&type=script&lang=js"

import "./PaymentContent.vue?vue&type=style&index=0&id=64139fe8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64139fe8"]])

export default __exports__